import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../Components/formElements/InputField";

import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import FileUploadComponent from "../../../Components/formElements/FileUploadComponent";
import FailureModal from "../../../Components/Modal/supplier_app/FailureModal";
import { getTodaysData, isValidNumber } from "../../../common/Validations";
import FileViewerModal from "../../../Components/FileViewer/FileViewerModal";
import toast from "react-hot-toast";
import ItemServiceV2 from "../../../services/ap_auto_appCommonService";
import { TextAreaField } from "../../../Components/formElements/TextAreaField";

const BudgetModal = React.forwardRef((props, ref) => {
  // eslint-disable-next-line
  const [disabled, setDisabled] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");
  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  /* pop failure modal data*/
  const FailureFuelEntry = {
    title: "Warning",
    ErrorMsg: "",
  };

  const [getFailureFuelEntry] = useState(FailureFuelEntry);
  // eslint-disable-next-line
  const [getErrorFields, setErrorFields] = useState([]);
  const [getShowFailureModal, setShowFailureFuelEntry] = useState(false);

  const [formInputs, setFormInputs] = useState({
    budgetDate: getTodaysData() || "",
    budgetDepartment: "",
    category: "",
    budgetSubCategory: "",
    allocatedAmount: "",
    plannedAmount: "",
    actualAmount: "",
    remainingAmount: "",
    budgetYear: "",
    paymentMode: "",
    remarks: "",
    supportingDocument: "",
  });

  const Departments = [
    { id: 1, name: "HR" },
    { id: 2, name: "IT" },
    { id: 3, name: "Finance" },
    { id: 4, name: "Transport" },
  ];

  const Category = [
    { id: 1, name: "Salary" },
    { id: 2, name: "Equipment" },
    { id: 3, name: "Travel" },
    { id: 4, name: "Office Supplies" },
  ];

  const message = {
    VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
    VALID_MAIL_ID: "Please enter a valid email address.",
    VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
    VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
    VALID_ALTERNATE_CONTACT_NUMBER:
      "Please enter a valid alternate contact number.",
    VALID_PURPOSE_JUSTIFICATION:
      "Please ensure the justification is under 500 characters.",
    VALID_POSTAL_CODE:
      "Enter a 6-character postal code with uppercase letters and numbers only",
    VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
    VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
    EXIStS_MAIL_ID: "Email already exists",
    EXIStS_CONTACT_NUMBER: "Contact Number already exists",
    EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
    EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
    FILL_REQUIRED_FIELD: "Please fill the required field",
    ALTERNATE_MAIL_ID: "Email ID is same",
    ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  };

  // For Upload Success
  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };

  useEffect(() => {
    if (!getDropdownData) return;

    const updatedFields = {
      [getDropdownData?.textField]: getDropdownData?.name,
      [getDropdownData?.textCode]: getDropdownData?.textCode,
      [getDropdownData?.textDesc]: getDropdownData?.textDesc,
    };

    if (getDropdownData?.textField === "budgetDepartment") {
      updatedFields.budgetDepartment = getDropdownData?.name;
      updatedFields.budgetDepartment = getDropdownData?.name;
    }
    if (getDropdownData?.textField === "category") {
      updatedFields.category = getDropdownData?.name;
      updatedFields.category = getDropdownData?.name;
    }
    if (getDropdownData?.textField === "paymentMode") {
      updatedFields.paymentMode = getDropdownData?.name;
      updatedFields.paymentMode = getDropdownData?.name;
    }

    setFormInputs((prev) => ({
      ...prev,
      ...updatedFields,
    }));
  }, [getDropdownData]);

  //Validations
  // eslint-disable-next-line
  const [validation, setValidation] = useState({
    budgetDate: getTodaysData() || "",
    budgetDepartment: "",
    category: "",
    budgetSubCategory: "",
    allocatedAmount: "",
    plannedAmount: "",
    actualAmount: "",
    remainingAmount: "",
    budgetYear: "",
    paymentMode: "",
    remarks: "",
    supportingDocument: "",
  });
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const handleInputChange = ({ target: { name, value } }) => {
    setFormInputs((prev) => {
      const updated = { ...prev, [name]: value };

      if (updated.allocatedAmount && updated.actualAmount) {
        updated.remainingAmount =
          Number(updated.allocatedAmount) - Number(updated.actualAmount);
      } else {
        updated.remainingAmount = "";
      }

      return updated;
    });
  };

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  const initialState = {
    budgetDate: getTodaysData() || "",
    budgetDepartment: "",
    category: "",
    budgetSubCategory: "",
    allocatedAmount: "",
    plannedAmount: "",
    actualAmount: "",
    remainingAmount: "",
    budgetYear: "",
    paymentMode: "",
    remarks: "",
    supportingDocument: "",
  };

  //handle cancel modal
  const handleCancel = () => {
    setFormInputs((prev) => ({ ...prev, ...initialState }));

    props.onHide();
  };

  const handleSave = async () => {
    setFormInputs((prev) => ({ ...prev, ...initialState }));
    const requiredFields = [];
    if (!isValidNumber(formInputs.allocatedAmount)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        allocatedAmount: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!isValidNumber(formInputs.plannedAmount)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        plannedAmount: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!isValidNumber(formInputs.remainingAmount)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        remainingAmount: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!isValidNumber(formInputs.actualAmount)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        actualAmount: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    let obj = {
      data: formInputs,
    };
    setDisabled(true);
    await ItemServiceV2.addBudget(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "added successfully", {
          duration: 2000,
          position: "top-right",
        });

        props.onHide();
        props.refreshData();
      } else {
        // setErrorMsg('*'+ item?.message);
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
  };

  const hideFailureModal = () => {
    setShowFailureFuelEntry(false);
  };

  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Budget</Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/* Removed the two fields */}

        {/*03 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                {/* <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible1 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility3}
                  ></i>
                </Col> */}
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">BD</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle"> Budget Details</span>
                  <span className="subHeaderTitle">Budget details</span>
                </Col>
              </Row>
            </h2>

            <div>
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="date"
                            // label="Budget Date "
                            label={
                              <>
                                <i className="bi bi-calendar-date labelIcon"></i>
                                Budget Date
                              </>
                            }
                            name="budgetDate"
                            id="budgetDate"
                            value={formInputs?.budgetDate}
                            onChange={handleInputChange}
                            // disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            // label="Department"
                            label={
                              <>
                                <i className="bi bi-building labelIcon"></i>
                                Department
                              </>
                            }
                            placeholder=""
                            data={Departments}
                            id=""
                            iconClassName="dropdownIcon"
                            name="budgetDepartment"
                            code="budgetDepartment"
                            description="budgetDepartment"
                            setValue={formInputs?.budgetDepartment}
                            getvalue={setDropdownData}
                            required={true}
                            // error={validation.country}
                            // disabled={editMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            // label="Category"
                            label={
                              <>
                                <i className="bi bi-folder labelIcon"></i>
                                Category
                              </>
                            }
                            placeholder=""
                            data={Category}
                            id="category"
                            iconClassName="dropdownIcon"
                            name="category"
                            code="category"
                            description="category"
                            setValue={formInputs?.category}
                            getvalue={setDropdownData}
                            required={true}
                            // error={validation.country}
                            // disabled={editMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Sub Category"
                            label={
                              <>
                                <i className="bi bi-layers labelIcon"></i>
                                Sub Category
                              </>
                            }
                            placeholder=""
                            name="budgetSubCategory"
                            id="budgetSubCategory"
                            error={validation.budgetSubCategory || ""}
                            value={formInputs?.budgetSubCategory || ""}
                            onChange={handleInputChange}
                            required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Allocated Amount "
                            label={
                              <>
                                <i className="bi bi-wallet2 labelIcon"></i>
                                Allocated Budget
                              </>
                            }
                            placeholder=""
                            name="allocatedAmount"
                            id="allocatedAmount"
                            error={validation.allocatedAmount || ""}
                            value={formInputs?.allocatedAmount || ""}
                            onChange={handleInputChange}
                            required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Planned Amount "
                            label={
                              <>
                                <i className="bi bi-bar-chart labelIcon"></i>
                                Planned Amount
                              </>
                            }
                            placeholder=""
                            name="plannedAmount"
                            id="plannedAmount"
                            onChange={handleInputChange}
                            value={formInputs?.plannedAmount || ""}
                            error={validation.plannedAmount || ""}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Actual Amount "
                            label={
                              <>
                                <i className="bi bi-receipt labelIcon"></i>
                                Actual Amount
                              </>
                            }
                            placeholder=""
                            name="actualAmount"
                            id="actualAmount"
                            value={formInputs?.actualAmount || ""}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Remaining Amount"
                            label={
                              <>
                                <i className="bi bi-calculator labelIcon"></i>
                                Remaining Budget
                              </>
                            }
                            placeholder=""
                            name="remainingAmount"
                            id="remainingAmount"
                            error={validation.remainingAmount || ""}
                            value={formInputs?.remainingAmount || ""}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Budget Year"
                            label={
                              <>
                                <i className="bi bi-calendar3 labelIcon"></i>
                                Budget Year
                              </>
                            }
                            placeholder=""
                            name="budgetYear"
                            id="budgetYear"
                            error={validation.budgetYear || ""}
                            value={formInputs?.budgetYear || ""}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <TextAreaField
                            className="inputBox"
                            // label="Remarks"
                            label={
                              <>
                                <i className="bi bi-chat-left-text labelIcon"></i>
                                Remarks
                              </>
                            }
                            placeholder=""
                            name="remarks"
                            id="remarks"
                            value={formInputs?.remarks || ""}
                            error={validation.remarks || ""}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={12}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <FileUploadComponent
                            id="supportingDocument"
                            name="supportingDocument"
                            // label="Supporting Document"
                            label={
                              <>
                                <i className="bi bi-paperclip labelIcon"></i>
                                Supporting Document
                              </>
                            }
                            allowedTypes={[
                              "image/png",
                              "image/jpeg",
                              "application/pdf",
                            ]}
                            multiple={true} // Change to false for single file selection
                            required={true}
                            onSuccessUpload={onSuccessUploadDocumentType}
                            value={formInputs?.supportingDocument || ""}
                          />
                        </Col>
                        <Col
                          xs={8}
                          md={2}
                          lg={2}
                          className="commLeftRightPadding"
                        >
                          {(formInputs?.supportingDocument && (
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() =>
                                handleViewFile(formInputs?.supportingDocument)
                              }
                            />
                          )) ||
                            "--"}
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            {
              <Row className="my-4 ">
                <Col
                  lg={{ span: 2, offset: 8 }}
                  className="d-flex justify-content-end mt-2"
                >
                  <button
                    className="btnTable btn-danger"
                    onClick={handleCancel}
                    disabled={disabled}
                  >
                    Cancel
                  </button>
                </Col>
                <Col lg={2} className="d-flex justify-content-end mt-2">
                  <button
                    className="btnTable"
                    disabled={disabled}
                    onClick={handleSave}
                  >
                    Save
                  </button>
                </Col>
              </Row>
            }
          </div>
        </div>
        <FileViewerModal
          show={getShowFileViewModal}
          onHide={handleViewFileHide}
          fileid={getFileViewData}
        />
        <FailureModal
          show={getShowFailureModal}
          onHide={hideFailureModal}
          failureFuelData={getFailureFuelEntry}
          requiredfields={getErrorFields}
        />
      </Modal.Body>
    </Modal>
  );
});

export default BudgetModal;
